/* ──────────────────────────────────────────────────────────────
   SEIZA NORTH · constellation engine
   Ported verbatim from the HTML mockup. Generates gallery-card and
   product-page constellation SVGs from raw star + line data.

   v3 — gallery cards now render the ACTUAL product print image, so the
   grid always shows exactly what the customer receives.
   v4 — card name restored; prices now read from Shopify via the
        [data-seiza-prices] block emitted by the Liquid section instead
        of being hardcoded in this file.
   ────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  // ───── PRODUCT DATA (12 zodiac) ─────
  // NOTE: no price here — price is authoritative in Shopify only. See priceMap().
  const products = {
    aries:       { name:'Aries',       kanji:'羊', kanjiFull:'牡羊座', dates:'March 21 — April 19' },
    taurus:      { name:'Taurus',      kanji:'牛', kanjiFull:'牡牛座', dates:'April 20 — May 20' },
    gemini:      { name:'Gemini',      kanji:'双', kanjiFull:'双子座', dates:'May 21 — June 20' },
    cancer:      { name:'Cancer',      kanji:'蟹', kanjiFull:'蟹座',   dates:'June 21 — July 22' },
    leo:         { name:'Leo',         kanji:'獅', kanjiFull:'獅子座', dates:'July 23 — August 22' },
    virgo:       { name:'Virgo',       kanji:'乙', kanjiFull:'乙女座', dates:'August 23 — September 22' },
    libra:       { name:'Libra',       kanji:'秤', kanjiFull:'天秤座', dates:'September 23 — October 22' },
    scorpio:     { name:'Scorpio',     kanji:'蠕', kanjiFull:'蠕座',   dates:'October 23 — November 21' },
    sagittarius: { name:'Sagittarius', kanji:'射', kanjiFull:'射手座', dates:'November 22 — December 21' },
    capricorn:   { name:'Capricorn',   kanji:'山', kanjiFull:'山羊座', dates:'December 22 — January 19' },
    aquarius:    { name:'Aquarius',    kanji:'水', kanjiFull:'水瓶座', dates:'January 20 — February 18' },
    pisces:      { name:'Pisces',      kanji:'魚', kanjiFull:'魚座',   dates:'February 19 — March 20' },
  };

  // ───── PRODUCT PRINT IMAGES (actual v3 prints — cards show what ships) ─────
  const productImages = {
    aries:       'https://cdn.shopify.com/s/files/1/0711/7291/5309/files/aries_product_v3.png?v=1793372243',
    taurus:      'https://cdn.shopify.com/s/files/1/0711/7291/5309/files/taurus_product_v3.png?v=1793372243',
    gemini:      'https://cdn.shopify.com/s/files/1/0711/7291/5309/files/gemini_product_v3.png?v=1793372243',
    cancer:      'https://cdn.shopify.com/s/files/1/0711/7291/5309/files/cancer_product_v3.png?v=1793372243',
    leo:         'https://cdn.shopify.com/s/files/1/0711/7291/5309/files/leo_product_v3.png?v=1793372243',
    virgo:       'https://cdn.shopify.com/s/files/1/0711/7291/5309/files/virgo_product_v3.png?v=1793372243',
    libra:       'https://cdn.shopify.com/s/files/1/0711/7291/5309/files/libra_product_v3.png?v=1793372243',
    scorpio:     'https://cdn.shopify.com/s/files/1/0711/7291/5309/files/scorpio_product_v3.png?v=1793372243',
    sagittarius: 'https://cdn.shopify.com/s/files/1/0711/7291/5309/files/sagittarius_product_v3.png?v=1793372243',
    capricorn:   'https://cdn.shopify.com/s/files/1/0711/7291/5309/files/capricorn_product_v3.png?v=1793372243',
    aquarius:    'https://cdn.shopify.com/s/files/1/0711/7291/5309/files/aquarius_product_v3.png?v=1793372243',
    pisces:      'https://cdn.shopify.com/s/files/1/0711/7291/5309/files/pisces_product_v3.png?v=1793372243',
    // Custom Edition card: a real customer-style print (Reykjavík, 16 April 1986)
    // rendered from the same engine the product page uses, so the card looks
    // like what ships instead of a sketch.
    custom:      'https://cdn.shopify.com/s/files/1/0711/7291/5309/files/custom_product.png?v=1793372243',
  };

  // ───── CONSTELLATION DRAWINGS (locked v2 — matches print PDFs) ─────
  const drawings = {
    aries:       { lines:['M 55 162 L 62 145', 'M 62 145 Q 85 130 110 115', 'M 110 115 Q 122 103 135 92', 'M 110 115 Q 128 127 148 138'], stars:[[55,162,1.39], [62,145,2.42], [110,115,3.16], [135,92,1.39], [148,138,1.22], [128,122,0.6], [128,105,0.5], [90,138,0.7]], accent:[110,115] },
    taurus:      { lines:['M 55 163 Q 75 150 96 140', 'M 137 163 Q 116 150 96 140', 'M 96 140 Q 78 118 60 96', 'M 96 140 Q 118 118 140 96'], stars:[[96,140,3.35], [55,163,1.74], [137,163,1.74], [60,96,2.09], [140,96,1.39], [74,152,0.7], [118,152,0.7], [74,122,0.5], [128,120,0.5], [45,178,0.6]], accent:[96,140] },
    gemini:      { lines:['M 89 82 Q 82 108 75 135', 'M 75 135 Q 65 160 55 185', 'M 75 135 Q 81 162 88 188', 'M 121 82 Q 122 110 125 140', 'M 125 140 Q 120 165 115 192', 'M 125 140 Q 137 165 148 192', 'M 89 82 L 121 82'], stars:[[89,82,2.6], [121,82,3.16], [75,135,1.74], [125,140,1.74], [55,185,1.48], [88,188,1.3], [115,192,1.3], [148,192,1.3], [105,82,0.6], [75,108,0.5]], accent:[121,82] },
    cancer:      { lines:['M 52 72 Q 65 85 78 98', 'M 78 98 L 96 118', 'M 96 118 Q 102 147 107 175', 'M 96 118 Q 122 141 150 162'], stars:[[52,72,1.39], [78,98,0.87], [96,118,2.42], [107,175,1.22], [150,162,2.09], [88,130,0.5], [130,148,0.5]], accent:[96,118] },
    leo:         { lines:['M 50.5 135.0 Q 45.0 113.0 56.0 96.5', 'M 56.0 96.5 Q 72.5 85.5 89.0 91.0', 'M 89.0 91.0 Q 97.2 113.0 100.0 137.8', 'M 100.0 137.8 L 139 152', 'M 139 152 Q 143 163 140 174', 'M 140 174 Q 121 157 100.0 137.8'], stars:[[50.5,135.0,1.74], [56.0,96.5,1.74], [89.0,91.0,1.91], [100.0,137.8,3.35], [139,152,1.74], [140,174,1.57], [72.5,107.5,0.8], [72.5,126.8,0.7], [121,162,0.5], [116.5,148.8,0.6]], accent:[100.0,137.8] },
    virgo:       { lines:['M 58 79 Q 80 96 106 112', 'M 137 73 Q 121 97 106 112', 'M 106 112 Q 115 145.0 121 177', 'M 121 177 Q 135 184 152 188', 'M 106 112 Q 90 139.0 69 162'], stars:[[58,79,1.48], [137,73,1.48], [106,112,2.42], [75.6,97.4,0.7], [121.4,97.4,0.7], [121,177,1.74], [152,188,2.79], [69,162,1.74], [115.3,147.2,0.5], [87.8,141.1,0.5]], accent:[152,188] },
    libra:       { lines:['M 55 110 Q 76 115.0 98 120', 'M 98 120 Q 121 112.5 143 105', 'M 143 105 Q 148 130 139 158', 'M 55 110 Q 48 138 63 165', 'M 63 165 Q 100 159 139 158'], stars:[[55,110,2.33], [98,120,1.57], [143,105,2.79], [139,158,1.74], [63,165,1.74], [100,106,0.6], [127,106,0.6], [143,130,0.5], [55,138,0.5], [110,161,0.5]], accent:[143,105] },
    scorpio:     { lines:['M 52 82 Q 63 88 75 95', 'M 75 95 Q 85 110 98 127', 'M 98 127 Q 110 152 118 174', 'M 118 174 Q 132 179 141 178', 'M 141 178 Q 148 168 146 154', 'M 146 154 Q 138 147 129 144'], stars:[[52,82,1.48], [75,95,1.48], [98,127,3.16], [118,174,1.74], [141,178,1.74], [146,154,1.57], [129,144,1.3], [85,108,0.6], [108,152,0.5], [139,166,0.5]], accent:[98,127] },
    sagittarius: { lines: ['M 58 95 Q 74 112 68 135', 'M 68 135 Q 76 158 58 175', 'M 68 135 Q 105 124 150 110'], stars: [[58,95,2.0],[68,135,1.74],[58,175,2.6],[150,110,1.91],[102,126,0.5],[126,117,0.6],[80,158,0.5],[96,90,0.4]], accent: [58,175] },
    capricorn:   { lines:['M 45 140 Q 55.5 107.5 76 83', 'M 76 83 Q 95.5 99.5 115 108', 'M 115 108 Q 138 138 165 170'], stars:[[45,140,1.91], [76,83,2.6], [115,108,1.57], [165,170,2.09], [60,110,0.4], [95,88,0.4], [140,138,0.5]], accent:[76,83] },
    aquarius:    { lines:['M 80 80 L 100 93', 'M 118 78 L 100 93', 'M 100 93 L 102 122', 'M 102 122 Q 115 145 130 170', 'M 130 170 Q 145 192 160 210'], stars:[[80,80,1.57], [118,78,1.57], [100,93,2.09], [102,122,1.39], [130,170,1.57], [160,210,1.74], [90,90,0.4], [110,90,0.4], [118,145,0.4], [147,192,0.4]], accent:[100,93] },
    pisces:      { lines:['M 55 119 Q 67 113 81 118', 'M 55 119 Q 45 130 51 141', 'M 81 118 Q 90 127 100 136', 'M 100 136 Q 105 145 111 155', 'M 111 155 Q 124 162 137 159', 'M 137 159 Q 145 152 139 145'], stars:[[55,119,1.74], [81,118,1.91], [51,141,1.74], [100,136,2.09], [111,155,1.91], [137,159,2.6], [139,145,1.74], [65,108,0.6], [93,124,0.5], [128,156,0.5]], accent:[137,159] },
  };

  // ───── CARD IMAGE STYLES (injected — keeps this change in one file) ─────
  (function injectCardStyles() {
    if (document.getElementById('seiza-card-img-style')) return;
    const st = document.createElement('style');
    st.id = 'seiza-card-img-style';
    st.textContent =
      '.poster-frame.has-img{aspect-ratio:1500/2121;background:#f3e9d2;}' +
      '.poster-frame.has-img img{width:100%;height:100%;object-fit:cover;display:block;}';
    (document.head || document.documentElement).appendChild(st);
  })();

  // ───── LIVE PRICE MAP ─────
  // Emitted by seiza-featured.liquid / seiza-shop.liquid as a
  // <script type="application/json" data-seiza-prices> block, so prices always
  // match Shopify and follow the customer's market/currency.
  let _priceMap = null;
  function priceMap() {
    if (_priceMap) return _priceMap;
    _priceMap = {};
    const el = document.querySelector('[data-seiza-prices]');
    if (el) {
      try {
        _priceMap = JSON.parse(el.textContent) || {};
      } catch (e) {
        console.warn('SEIZA: could not parse price map', e);
      }
    }
    return _priceMap;
  }

  function rootUrl() {
    const r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (r || '/').replace(/\/$/, '');
  }

  // ───── CONSTELLATION FITTING HELPERS ─────
  function fitConstellation(d, targetW, targetH, targetCX, targetCY, fillRatio) {
    const xs = [], ys = [];
    for (const s of d.stars) { xs.push(s[0]); ys.push(s[1]); }
    for (const ln of d.lines) {
      const toks = ln.split(/\s+/).filter(t => t);
      for (let i = 0; i < toks.length; i++) {
        const c = toks[i];
        if (c === 'M' || c === 'L') {
          xs.push(parseFloat(toks[i+1])); ys.push(parseFloat(toks[i+2]));
        } else if (c === 'Q') {
          xs.push(parseFloat(toks[i+1])); ys.push(parseFloat(toks[i+2]));
          xs.push(parseFloat(toks[i+3])); ys.push(parseFloat(toks[i+4]));
        }
      }
    }
    const minx = Math.min(...xs), maxx = Math.max(...xs);
    const miny = Math.min(...ys), maxy = Math.max(...ys);
    const w = maxx - minx, h = maxy - miny;
    const scale = Math.min(targetW * fillRatio / w, targetH * fillRatio / h);
    return { scale, srcCX: (minx + maxx) / 2, srcCY: (miny + maxy) / 2, tCX: targetCX, tCY: targetCY };
  }

  function tfmPt(x, y, t) {
    return [t.tCX + (x - t.srcCX) * t.scale, t.tCY + (y - t.srcCY) * t.scale];
  }

  function tfmPath(pathStr, t) {
    const toks = pathStr.split(/\s+/).filter(s => s);
    const out = [];
    let i = 0;
    while (i < toks.length) {
      const c = toks[i];
      if (c === 'M' || c === 'L') {
        const [tx, ty] = tfmPt(parseFloat(toks[i+1]), parseFloat(toks[i+2]), t);
        out.push(c, tx.toFixed(2), ty.toFixed(2));
        i += 3;
      } else if (c === 'Q') {
        const [cx, cy] = tfmPt(parseFloat(toks[i+1]), parseFloat(toks[i+2]), t);
        const [tx, ty] = tfmPt(parseFloat(toks[i+3]), parseFloat(toks[i+4]), t);
        out.push(c, cx.toFixed(2), cy.toFixed(2), tx.toFixed(2), ty.toFixed(2));
        i += 5;
      } else {
        out.push(c); i++;
      }
    }
    return out.join(' ');
  }

  // ───── GALLERY CARD SVG (3:4 thumbnail) — fallback if no product image ─────
  function buildCardSVG(key) {
    const p = products[key];
    const d = drawings[key];
    if (!d) return '';
    const t = fitConstellation(d, 160, 140, 100, 110, 0.88);
    let s = '<svg viewBox="0 0 200 260" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">';
    s += '<text x="180" y="30" text-anchor="end" font-family="Shippori Mincho B1" font-size="11" fill="#c98a72" font-weight="500">'+p.kanjiFull+'</text>';
    s += '<g stroke="#3d3d47" stroke-width="0.55" fill="none" stroke-linecap="round" opacity=".85">';
    for (const ln of d.lines) s += '<path d="'+tfmPath(ln, t)+'"/>';
    s += '</g>';
    s += '<g fill="#3d3d47">';
    for (const [x, y, r] of d.stars) {
      const [tx, ty] = tfmPt(x, y, t);
      const sr = Math.max(0.45, (r * 1.0 + 0.3) * 0.4);
      s += '<circle cx="'+tx.toFixed(2)+'" cy="'+ty.toFixed(2)+'" r="'+sr.toFixed(2)+'"/>';
    }
    s += '</g>';
    const [aX, aY] = tfmPt(d.accent[0], d.accent[1], t);
    s += '<circle cx="'+aX.toFixed(2)+'" cy="'+aY.toFixed(2)+'" r="2.6" fill="none" stroke="#c98a72" stroke-width=".55"/>';
    s += '<text x="20" y="240" font-family="Shippori Mincho B1" font-size="11" fill="#3d3d47">'+p.name+'</text>';
    s += '<text x="20" y="252" font-family="EB Garamond" font-style="italic" font-size="8" fill="#84848c">'+p.dates+'</text>';
    s += '<rect x="170" y="232" width="14" height="14" fill="#c98a72"/>';
    s += '<text x="177" y="242" text-anchor="middle" font-family="Shippori Mincho B1" font-size="8" font-weight="500" fill="#f3e9d2">北</text>';
    s += '</svg>';
    return s;
  }

  function buildCustomCardSVG() {
    return '<svg viewBox="0 0 200 260" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'+
      '<text x="180" y="26" text-anchor="end" font-family="Shippori Mincho B1" font-size="11" fill="#c98a72" font-weight="500">星</text>'+
      '<text x="180" y="40" text-anchor="end" font-family="Shippori Mincho B1" font-size="11" fill="#c98a72" font-weight="500">空</text>'+
      '<circle cx="100" cy="135" r="65" fill="none" stroke="#3d3d47" stroke-width="0.4" opacity="0.15"/>'+
      '<g fill="#3d3d47"><circle cx="24.1" cy="87.5" r="0.50" opacity="0.36"/><circle cx="183.7" cy="86.8" r="0.59" opacity="0.30"/><circle cx="105.1" cy="174.7" r="0.35" opacity="0.29"/><circle cx="113.2" cy="100.0" r="0.56" opacity="0.18"/><circle cx="30.4" cy="118.6" r="0.62" opacity="0.38"/><circle cx="94.3" cy="64.3" r="0.33" opacity="0.20"/><circle cx="118.6" cy="80.5" r="0.37" opacity="0.39"/><circle cx="60.5" cy="199.3" r="0.72" opacity="0.28"/><circle cx="40.5" cy="76.4" r="0.71" opacity="0.38"/><circle cx="14.3" cy="84.5" r="0.72" opacity="0.40"/><circle cx="98.8" cy="98.9" r="0.39" opacity="0.24"/><circle cx="159.9" cy="41.4" r="0.47" opacity="0.29"/><circle cx="103.7" cy="193.7" r="0.53" opacity="0.22"/><circle cx="31.7" cy="151.7" r="0.57" opacity="0.36"/><circle cx="166.8" cy="30.1" r="0.45" opacity="0.28"/><circle cx="38.9" cy="93.0" r="0.66" opacity="0.21"/><circle cx="111.7" cy="34.0" r="0.31" opacity="0.24"/><circle cx="125.1" cy="173.5" r="0.35" opacity="0.32"/><circle cx="125.8" cy="105.5" r="0.56" opacity="0.23"/><circle cx="33.6" cy="32.3" r="0.68" opacity="0.40"/><circle cx="90.4" cy="191.5" r="0.37" opacity="0.26"/><circle cx="108.8" cy="106.1" r="0.34" opacity="0.17"/><circle cx="165.4" cy="194.6" r="0.50" opacity="0.30"/><circle cx="122.1" cy="81.1" r="0.69" opacity="0.17"/><circle cx="114.0" cy="111.3" r="0.58" opacity="0.30"/><circle cx="149.1" cy="147.4" r="0.68" opacity="0.19"/></g>'+
      '<g stroke="#3d3d47" stroke-width="0.6" fill="none" opacity="0.5" stroke-linecap="round">'+
      '<line x1="65" y1="105" x2="85" y2="120"/><line x1="85" y1="120" x2="115" y2="115"/>'+
      '<line x1="115" y1="115" x2="135" y2="135"/><line x1="85" y1="120" x2="100" y2="160"/>'+
      '</g><g fill="#3d3d47">'+
      '<circle cx="65" cy="105" r="1.6"/><circle cx="85" cy="120" r="2.2"/>'+
      '<circle cx="115" cy="115" r="1.5"/><circle cx="135" cy="135" r="1.8"/>'+
      '<circle cx="100" cy="160" r="2"/><circle cx="75" cy="155" r="1"/>'+
      '<circle cx="145" cy="100" r="1"/><circle cx="55" cy="130" r="0.8"/>'+
      '<circle cx="155" cy="170" r="0.9"/></g>'+
      '<circle cx="115" cy="115" r="7.5" fill="none" stroke="#c98a72" stroke-width=".9"/>'+
      '<text x="20" y="240" font-family="Shippori Mincho B1" font-size="11" fill="#3d3d47">Your sky</text>'+
      '<text x="20" y="252" font-family="EB Garamond" font-style="italic" font-size="8" fill="#84848c">Custom edition</text>'+
      '<rect x="170" y="232" width="14" height="14" fill="#c98a72"/>'+
      '<text x="177" y="242" text-anchor="middle" font-family="Shippori Mincho B1" font-size="8" font-weight="500" fill="#f3e9d2">北</text>'+
      '</svg>';
  }

  // ───── BUILD CARD (links to /products/{handle}) ─────
  function buildCard(key, opts) {
    opts = opts || {};
    const isCustom = key === 'custom';
    const handle = isCustom ? 'custom-edition' : key;
    const name = isCustom ? 'Your sky' : products[key].name;
    const info = priceMap()[handle];

    const div = document.createElement('a');
    div.href = rootUrl() + '/products/' + handle;
    div.className = 'poster-card' + (isCustom ? ' custom' : '');
    div.dataset.key = key;
    div.setAttribute('aria-label', name);

    let frameClass = 'poster-frame';
    let frameInner;
    if (productImages[key]) {
      frameClass = 'poster-frame has-img';
      frameInner = '<img src="' + productImages[key] +
        '" alt="' + name + ' constellation print — SEIZA NORTH"' +
        (opts.eager ? '' : ' loading="lazy"') + '>';
    } else if (isCustom) {
      frameInner = buildCustomCardSVG();
    } else {
      frameInner = buildCardSVG(key);
    }

    // Price is authoritative in Shopify. If the product is not published or the
    // map is missing, omit the price rather than print a number that may be wrong.
    const priceHTML = info && info.price
      ? '<span class="price">' + info.price + '</span>'
      : '';

    div.innerHTML =
      '<div class="' + frameClass + '">' + frameInner + '</div>' +
      '<div class="poster-meta">' +
        '<span class="name">' + name + '</span>' +
        priceHTML +
      '</div>';
    return div;
  }

  // ───── EXPOSE ─────
  window.SeizaNorth = window.SeizaNorth || {};
  window.SeizaNorth.products = products;
  window.SeizaNorth.drawings = drawings;
  window.SeizaNorth.fitConstellation = fitConstellation;
  window.SeizaNorth.tfmPt = tfmPt;
  window.SeizaNorth.tfmPath = tfmPath;
  window.SeizaNorth.buildCardSVG = buildCardSVG;
  window.SeizaNorth.buildCustomCardSVG = buildCustomCardSVG;
  window.SeizaNorth.buildCard = buildCard;
  window.SeizaNorth.priceMap = priceMap;

  // ───── AUTO-POPULATE GRIDS ─────
  // Featured grid: reads data-keys (comma-separated) and populates with cards.
  function populateGrid(el) {
    if (!el || el.dataset.populated === '1') return;
    const keys = (el.dataset.keys || '').split(',').map(s => s.trim()).filter(Boolean);
    // First row eager — lazy-loading the LCP image measurably hurt first paint.
    keys.forEach((k, i) => el.appendChild(buildCard(k, { eager: i < 4 })));
    el.dataset.populated = '1';
  }

  function init() {
    document.querySelectorAll('[data-constellation-grid]').forEach(populateGrid);
    // Home page custom-edition preview (single SVG slot).
    // seiza-custom.js replaces this with the real Tanabata 1644 Kyoto sky once
    // it runs; this is only the placeholder so the slot is never empty.
    document.querySelectorAll('[data-custom-preview]').forEach(slot => {
      if (slot.dataset.populated === '1') return;
      slot.innerHTML = buildCustomCardSVG();
      slot.dataset.populated = '1';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
